import { render } from "./DeletePersona.vue?vue&type=template&id=385f4baa"
import script from "./DeletePersona.vue?vue&type=script&lang=js"
export * from "./DeletePersona.vue?vue&type=script&lang=js"

import "./DeletePersona.vue?vue&type=style&index=0&id=385f4baa&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__